module.exports = __webpack_public_path__ + "static/media/icono-hellmanns-kilos.e39d9b6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono-hellmanns-kilos.png
// module id = 296
// module chunks = 0